import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import {FC} from 'react'

export type OptionType = {
  id: string | number
  label: string
}

interface IAutoCompleteProps {
  id: string
  label?: string
  placeholder?: string
  limitTags?: number
  value: OptionType | OptionType[] | null
  options: OptionType[]
  onChange: any
  multipleOptions: boolean
}

const AutoComplete: FC<IAutoCompleteProps> = ({
  id,
  label = 'Label',
  placeholder = 'Placeholder',
  limitTags = 1,
  value,
  multipleOptions = true,
  options,
  onChange,
}) => {
  return (
    <Autocomplete
      id={`autocomplete-${id}`}
      multiple={multipleOptions}
      value={value}
      options={options}
      onChange={onChange}
      limitTags={limitTags}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
    />
  )
}

export default AutoComplete
